import { render, staticRenderFns } from "./DepNews.vue?vue&type=template&id=d7449a88&"
import script from "./DepNews.vue?vue&type=script&lang=js&"
export * from "./DepNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports